export default {
  path: '/page',
  name: 'system',
  component: () => import('@/layouts/BaseLayout'),
  children: [],
}